
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import withLabelDemo from './demo/with-label.twig';
import './demo/styles.scss';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Components/Radio" argTypes={{
      disabled: {
        type: {
          name: 'boolean'
        }
      }
    }} mdxType="Meta" />
    <h1>{`Radio`}</h1>
    <p><inlineCode parentName="p">{`c-radio`}</inlineCode>{` may be applied to any `}<inlineCode parentName="p">{`<input type="radio">`}</inlineCode>{` element. They are larger than native radio elements and more visually consistent with our `}<a parentName="p" {...{
        "href": "/docs/components-checkbox--Enabled"
      }}>{`checkbox`}</a>{`, `}<a parentName="p" {...{
        "href": "/docs/components-input--text-elements"
      }}>{`input`}</a>{` and `}<a parentName="p" {...{
        "href": "/docs/components-button--elements"
      }}>{`button`}</a>{` components.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Enabled" parameters={{
        docs: {
          source: {
            code: `{% include '@cloudfour/components/radio/radio.twig' with {
  name: 'demo-radio-enabled',
  value: 'example',
  checked: true,
} only %}`
          }
        }
      }} mdxType="Story">
    {args => withLabelDemo(args)}
  </Story>
    </Canvas>
    <p>{`Radios appear more subtle and less actionable when the `}<inlineCode parentName="p">{`disabled`}</inlineCode>{` attribute is set.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Disabled" args={{
        disabled: true
      }} parameters={{
        docs: {
          source: {
            code: `{% include '@cloudfour/components/radio/radio.twig' with {
  name: 'demo-radio-disabled',
  value: 'example',
  checked: true,
  disabled: true,
} only %}`
          }
        }
      }} mdxType="Story">
    {args => withLabelDemo(args)}
  </Story>
    </Canvas>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const enabled = (args => withLabelDemo(args));
enabled.storyName = 'Enabled';
enabled.parameters = { storySource: { source: 'args => withLabelDemo(args)' }, ...{
  docs: {
    source: {
      code: `{% include '@cloudfour/components/radio/radio.twig' with {
  name: 'demo-radio-enabled',
  value: 'example',
  checked: true,
} only %}`
    }
  }
} };

export const disabled = (args => withLabelDemo(args));
disabled.storyName = 'Disabled';
disabled.args = {
  disabled: true
};
disabled.parameters = { storySource: { source: 'args => withLabelDemo(args)' }, ...{
  docs: {
    source: {
      code: `{% include '@cloudfour/components/radio/radio.twig' with {
  name: 'demo-radio-disabled',
  value: 'example',
  checked: true,
  disabled: true,
} only %}`
    }
  }
} };

const componentMeta = { title: 'Components/Radio', argTypes: {
  disabled: {
    type: {
      name: 'boolean'
    }
  }
}, includeStories: ["enabled","disabled"],  };

const mdxStoryNameToKey = {"Enabled":"enabled","Disabled":"disabled"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;